// Örnek servis codiagno login
import axios from '../javascript/custom-axios';
let RESOURCE_NAME = 'sampleExcels';

export default {
  /**
   * Creates a new sample excel.
   * @param {{
   *   Name: string,
   *   Description: string,
   *   FilePath: string,
   *   FileUri: string,
   *   DocRoletype: number
   * }} body
   * @returns {Promise<any>}
   * @example
   * const body = {
   *   "Name": "string",
   *   "Description": "string",
   *   "FilePath": "string",
   *   "FileUri": "string",
   *   "DocRoletype": 0
   * };
   */
  add(body) {
    return axios.post(`${RESOURCE_NAME}/add`, body);
  },

  /**
   * Get sample excel list.
   * @param {{ page: number, pageSize: number, IsAdmin: boolean, DocRoletype: 0 | 1 | 2 }} params
   * @returns {Promise<any>}
   */
  get(params) {
    return axios.get(`${RESOURCE_NAME}/get`, { params });
  },

  /**
   * Update a sample excel.
   * @param {{
   *   Id: string,
   *   Name: string,
   *   Description: string,
   *   FilePath: string,
   *   FileUri: string,
   *   DocRoletype: number
   * }} body
   * @returns {Promise<any>}
   * @example
   * const body = {
   *   "Id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
   *   "Name": "string",
   *   "Description": "string",
   *   "FilePath": "string",
   *   "FileUri": "string",
   *   "DocRoletype": 0
   * };
   */
  update(body) {
    return axios.put(`${RESOURCE_NAME}/update`, body);
  },

  /**
   * Delete a sample excel.
   * @param {string} sampleExcelId
   * @returns {Promise<any>}
   */
  delete(sampleExcelId) {
    return axios.delete(`${RESOURCE_NAME}/delete?Id=${sampleExcelId}`);
  },
};
